import { Grid, Paper, withStyles, WithStyles } from "@material-ui/core";
import React from "react";
import { BlueButton } from "../../components/Buttons/BlueButton";
import { styles } from "./RegisterForm.styles";
import { IAgrees } from "../AcceptTermsConditionsComponent";
import { RegisterForm } from "./RegisterForm";

export type RegisterFormVariant = "register" | "addNewUserAdmin" | "saveUserDetails";

const buttonTitles = {
    register: "Register",
    addNewUserAdmin: "Create user",
    saveUserDetails: "Save details"
};

export interface IRegisterFormWithButtonProps extends WithStyles<typeof styles> {
    details: any;
    registerError?: any;
    handleChange: any;
    handleCountry: any;
    handleSubmit?: any;
    allCountries: any;
    type?: RegisterFormVariant;
    handleHowDidYouHearAboutUs?: any;
    errors: any;
    anotherDeliveryAddress: any;
    setAnotherDeliveryAddress: any;
    agreeTypes?: IAgrees;
}

const RegisterFormWithButtonPure: React.FunctionComponent<IRegisterFormWithButtonProps> = ({
    details,
    registerError,
    handleChange,
    handleCountry,
    handleSubmit,
    handleHowDidYouHearAboutUs,
    allCountries,
    type,
    classes,
    errors,
    anotherDeliveryAddress,
    setAnotherDeliveryAddress,
    agreeTypes
}) => {
    const [agrees, setAgrees] = React.useState(
        agreeTypes || {
            agreePrivacyNotice: false,
            agreeClientLegal: false
        }
    );

    const handleAgree = event => {
        setAgrees({
            ...agrees,
            [event.target.name]: !agrees[event.target.name]
        });
    };

    const formIsValid = (): boolean => {
        let isValid =
            !errors.includes("firstName") &&
            !errors.includes("lastName") &&
            !errors.includes("addressLine1") &&
            !errors.includes("postcode") &&
            !errors.includes("city") &&
            !errors.includes("company") &&
            details.firstName?.length !== 0 &&
            details.lastName?.length !== 0 &&
            details.addressLine1?.length !== 0 &&
            details.postcode?.length !== 0 &&
            details.city?.length !== 0 &&
            details.company?.length !== 0 &&
            details.country?.length !== 0;

        if (type === "saveUserDetails" || type === "register")
            isValid = isValid && agrees.agreeClientLegal && agrees.agreePrivacyNotice;

        if (type === "addNewUserAdmin" || type === "register")
            isValid = isValid && agrees.agreeClientLegal && !errors.includes("email") && details.email?.length !== 0;

        return isValid;
    };

    const isFormValid = formIsValid();

    return (
        <Paper className={classes.formBox}>
            <Grid container spacing={1}>
                <RegisterForm
                    type={type}
                    details={details}
                    registerError={registerError}
                    handleChange={handleChange}
                    handleCountry={handleCountry}
                    allCountries={allCountries}
                    handleHowDidYouHearAboutUs={handleHowDidYouHearAboutUs}
                    anotherDeliveryAddress={anotherDeliveryAddress}
                    setAnotherDeliveryAddress={setAnotherDeliveryAddress}
                    agrees={agrees}
                    handleAgree={handleAgree}
                />

                <Grid item xs={12}>
                    <BlueButton onClick={handleSubmit} disabled={!isFormValid}>
                        {buttonTitles[type] || "Register"}
                    </BlueButton>
                </Grid>
            </Grid>
        </Paper>
    );
};

export const RegisterFormWithButton = withStyles(styles)(RegisterFormWithButtonPure);
